import React from 'react'
import { RouteComponentProps, useHistory } from 'react-router'
import { Formik, Field, Form, ErrorMessage, FormikProps } from 'formik'
import * as Yup from 'yup'

import { authStore } from 'adminConsole/store'
import { Path } from 'adminConsole'
import { AdminLayout } from 'adminConsole/layout'
import toastr from 'toastr'

interface ResetPwdRequest {
  account: string
}

export const PasswordReset: React.FC<RouteComponentProps> = props => {
  return (
    <AdminLayout title="忘記密碼">
      <Formik
        initialValues={{ account: '' }}
        validationSchema={Yup.object().shape({
          account: Yup.string().trim().required('必填欄位！'),
        })}
        onSubmit={async ({ account }, { setStatus, setSubmitting }) => {
          try {
            setStatus(undefined)

            await authStore.resetPassword(account)
            toastr.info('請查收信箱，並於登入後立即重設密碼')

            props.history.push(Path.Login)
          } catch (e: any) {
            setStatus(e.message)
            setSubmitting(false)
          }
        }}
        component={formikProps => ResetPwdForm(formikProps)}
      />
    </AdminLayout>
  )
}

const ResetPwdForm = ({ errors, status, touched, isSubmitting }: FormikProps<ResetPwdRequest>) => {
  const navigate = useHistory()
  const goBack = () => navigate.goBack()

  return (
    <Form>
      <div className="row">
        <div className="form-group col-12 col-sm-6">
          <label htmlFor="account">Email</label>
          <Field
            name="account"
            type="text"
            className={'form-control' + (errors.account && touched.account ? ' is-invalid' : '')}
          />
          <ErrorMessage name="account" component="div" className="invalid-feedback" />
        </div>
      </div>

      {status && <div className="text-danger">{status}</div>}

      <div className="row mt-5">
        <div className="col-12 d-flex justify-content-between">
          <button type="button" className="btn btn-light" onClick={goBack}>
            取消
          </button>
          <button type="submit" className="btn btn-secondary ml-auto" disabled={isSubmitting}>
            送出
          </button>
        </div>
      </div>
    </Form>
  )
}
